var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',{staticClass:"404"},[_c('h1',[_vm._v(_vm._s(_vm.msg))]),_c('h2',[_vm._v("There's Nothing Here")]),_c('a',{attrs:{"href":"/"}},[_vm._v("Return Home")])])}
var staticRenderFns = []

export { render, staticRenderFns }